<div class="na-templates-dialog">
  <div>
    <span style="margin-left:10px">Send notification to additional recipients</span>
    <p style="margin-left:10px">By clicking on “Send notification”, the additional recipients will be added to the existing recipients list and the notification will be sent to the newly added recipients.</p>
    <p class="rcp-error-msg" *ngIf="isWarn">Please remove the duplicate contacts
      <span title="Duplicate recipient warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
    <p class="rcp-error-msg" *ngIf="isLimit">The maximum number of contacts is {{contactLimitNumber}}. Limit exceeded by {{excessList}}
      <span title="Duplicate recipient warning" style="height: 24px;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" style="width: 24px; vertical-align: sub;"><path fill="#D0342C" d="M21.912 20.173L12.813 3.478c-.265-.442-.795-.618-1.237-.353a.69.69 0 0 0-.353.353L2.125 20.173c-.265.442-.089.972.353 1.237.088.088.265.088.442.088h18.197c.53 0 .883-.441.883-.883 0-.177 0-.265-.088-.442zm-9.01-2.208h-1.767v-1.767H12.9v1.767zm0-3.534h-1.767v-5.3H12.9v5.3z"></path></svg>
      </span>.
    </p>
  </div>
  <div class="import-dialog-content">
  <dl-notification-add-recipients-template  [duplicates$]="duplicates$" [contactList]="contactList"  [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newFeedbackOption" [displayedColumns]="templateColumn" [tableData]="templateData" [isDeleteDisabledCheck]="isDeleteDisabledCheck_dialog" *ngIf="templateData?.length > 0" (isFoRowSelected)="getSelectedRowInTemplate($event)" (isRecipientAdded)="getTableData($event)" (selectionChanged)="isDeleteDisabled = $event === 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)"></dl-notification-add-recipients-template>
  </div>
  <div class="na-dialog-actions" style="display:flex">
    <div>
    <owc-button color="primary" [disabled]="isDeleteDisabled" (click)="deleteRows()" >
      Delete
    </owc-button>
  </div>
    <div class="na-dialog-actions-item" style="display: flex;">
    <owc-button
       class="cancel-button"
       (click)="cancelClicked()"
       tabindex="-1"
    > Cancel
    </owc-button>
   
    <div class="na-dropdown-button">
      <div class="dropdown-list" *ngIf="isAddRecipientBtnExpanded">
          <owc-button class="dropdown-item" (click)="manualAddRecipientClicked()">Manually add recipient</owc-button>
          <hr class="dropdown-divider">
          <owc-button class="dropdown-item" (click)="contactListImportClicked()">Import from file</owc-button>
          <hr class="dropdown-divider">
          <owc-button class="dropdown-item" (click)="contactListFromRexisSap()">Import from Rexis/SAP</owc-button>
      </div>
      <ng-container *ngIf="openFromFile">
      <owc-modal-dialog size="small" [(ngModel)]="openFromFile">
        <dl-import-dialog-file size="small" [inputData]="inputData" (dialogClose)="handleDialogClose($event)"></dl-import-dialog-file>

      </owc-modal-dialog>
    </ng-container>
      <owc-modal-dialog size="small" [(ngModel)]="fromRexisap">
        <ng-container *ngIf="fromRexisap">
        <dl-rexis-sap-dialog [data]="data" (dialogClose)="onRexisSapClosed($event)"></dl-rexis-sap-dialog>
      </ng-container>
      </owc-modal-dialog>
      <owc-modal-dialog size="small" [(ngModel)]="manualAddRecipient">
        <ng-container >
        <dl-import-dialog-file size="small"></dl-import-dialog-file>
      </ng-container>
      </owc-modal-dialog>
      <owc-button (click)="addRecipientClicked()" [disabled]="isAddRecipientBtnDisabled" [class.btn-expanded]="isAddRecipientBtnExpanded" class="btn-add-recipient" mat-stroked-button one-secondary-button>
        <span>Add recipients</span>
    </owc-button>
  </div>
    <owc-button color="primary" [disabled]="isSendNotificationDisabled || isLimitDis || isWarnDis" (click)="sendNotificationCall()" >
      Send notification
    </owc-button>
  </div>
  </div>
</div>

<ng-template #EmptyContactTemplate>
  <div class="emptyRecipientAlertDialog">
    
    <b>Recipient list upload is not possible.</b>
    <p>For the following recipients the email address is missing. Please correct the data and upload it again.</p>
    <table cellpadding="6px">
      <thead>
        <th>Row Index</th>
        <th>Customer Id</th>
        <th>Customer Name</th>
        <th>Customer Contact Name</th>
      </thead>
      <tbody>
        <tr *ngFor="let recipient of emptyContactList.emptyDataRow">
          <td>{{ recipient.rowIndex }}</td>
          <td>{{ recipient.customerId }}</td>
          <td>{{ recipient.customerName }}</td>
          <td>{{ recipient.customerContactName }}</td>
        </tr>
      </tbody>
    </table>
    <div class="emptyDialogCloseDiv">
      <owc-button color="primary" (click)="closeEmptyAlertDialog()" >
        Ok
      </owc-button>
    </div>

  </div>
</ng-template>
